import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { BubbleAlignment, BubbleShape } from "./Banner-Types";
import { useMediaQuery, useTheme } from "@mui/material";
import { shapeStyling, alignStyling } from "./Banner-utils";
export const useBanner = (sequenceNumber) => {
    var _a;
    const { store } = useOrderFlow();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((m) => m.ModuleName === ModuleNames.BANNER && m.Sequence === sequenceNumber && m.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { BannerImage, ShowTextBlock, HeaderandBodyText, BlockAlignment, ShapeType, BorderColor, MaxImageHeightDesktop, MaxImageHeightMobile, } = moduleConfig;
    let image = store.model.UploadedImagesUrl + BannerImage;
    if (!BannerImage)
        image = "";
    let buffer = 0;
    if (BlockAlignment === BubbleAlignment.Right)
        buffer = 100;
    if (BlockAlignment === BubbleAlignment.Right &&
        (ShapeType === BubbleShape.Circle ||
            ShapeType === BubbleShape.RightParallelogram ||
            ShapeType === BubbleShape.LeftParallelogram))
        buffer = 90;
    let textStyle = {};
    if (isMobile) {
        textStyle = {
            padding: theme.spacing(1, 1),
            backgroundColor: "white",
        };
    }
    else {
        textStyle = Object.assign({ width: "50%", position: "absolute", top: "50%", transform: "none" }, alignStyling(BlockAlignment, ShapeType, true, buffer));
    }
    const shapeStyle = shapeStyling(ShapeType, isMobile);
    const bubbleStyle = Object.assign(Object.assign({ border: `solid 8px ${BorderColor}` }, alignStyling(BlockAlignment, ShapeType, false, 10)), shapeStyle);
    return {
        bannerImage: image,
        showTextBlock: ShowTextBlock,
        bubbleText: HeaderandBodyText,
        textStyle,
        bubbleStyle,
        mobileImageMaxHeight: MaxImageHeightMobile,
        desktopImageMaxHeight: MaxImageHeightDesktop,
    };
};
